import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface IconClickEvent {
  iconClickAction: string;
}

@Component({
  selector: "card-section-header",
  templateUrl: "card-section-header.component.html",
})
export class CardSectionHeaderComponent {
  // Inputs
  @Input() title: string;
  @Input() iconClickAction?: string = "default";
  @Input() icon?: string;
  @Input() marginTop?: string = "5px";
  @Input() marginBottom?: string = "5px";

  // Outputs
  @Output() iconClickActionEvent = new EventEmitter<IconClickEvent>();

  // Icon Click Event
  onIconClick(): void {
    this.iconClickActionEvent.emit({ iconClickAction: this.iconClickAction });
  }
}



// WEBPACK FOOTER //
// ./src/components/card-section-header/card-section-header.component.ts